var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.74953V13.1245C17.4995 13.2135 17.48 13.3014 17.4428 13.3822C17.4056 13.463 17.3516 13.535 17.2844 13.5933C16.0906 14.6269 14.9492 14.9995 13.8609 14.9995C12.3836 14.9995 11.0039 14.3167 9.72031 13.6831C7.64609 12.6558 5.84297 11.7659 3.75 13.4191V16.8745C3.75 17.0403 3.68415 17.1993 3.56694 17.3165C3.44973 17.4337 3.29076 17.4995 3.125 17.4995C2.95924 17.4995 2.80027 17.4337 2.68306 17.3165C2.56585 17.1993 2.5 17.0403 2.5 16.8745V3.74953C2.5006 3.66049 2.52022 3.57261 2.55754 3.49176C2.59486 3.41092 2.64903 3.33899 2.71641 3.28078C5.52891 0.844841 8.05312 2.0925 10.2781 3.19328C12.4219 4.25422 14.2805 5.1714 16.4656 3.28078C16.5559 3.20249 16.6668 3.15173 16.7851 3.13454C16.9034 3.11734 17.0241 3.13443 17.133 3.18376C17.2419 3.2331 17.3343 3.31262 17.3993 3.4129C17.4644 3.51318 17.4993 3.63 17.5 3.74953Z",
    fill: "#FFB81C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentFlag);
export default __webpack_public_path__ + "static/media/current-flag.96e87683eefe7adc903d7ac09f6fc738.svg";
export { ForwardRef as ReactComponent };